import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Collection from './views/Collection.vue'
import Product from './views/Product.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { hasLanding: true }
    },
    {
      path: '/shop',
      redirect: '/'
    },
    {
      path: '/products/:handle',
      name: 'product',
      component: Product,
      props: true
    },
    {
      path: '/collections/:slug',
      name: 'collection',
      component: Collection,
      props: true
    },
    {
      path: '/collections/:slug/products/:handle',
      name: 'collection__product',
      component: Product,
      props: true
    },
    // {
    //   path: '/policies/:slug',
    //   name: 'policy',
    //   component: () => import(/* webpackChunkName: "about" */ './views/Policy.vue'),
    //   props: true
    // },
    {
      path: '/:slug',
      name: 'page',
      component: () => import(/* webpackChunkName: "page" */ './views/Page.vue'),
      props: true
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
